export class DispositifActivity {
  constructor(
    public readonly id: number | undefined,
    public readonly name: string,
    public readonly active: boolean,
    public readonly description?: string,
  ) {}
}

export interface DispositifCreateData {
  name: string;
  description?: string;
  startDate: string;
  endDate?: string;
  active: boolean;
  allActivities: boolean;
  authorizedActivityIds: number[];
  participantIds: number[];
}

export class Dispositif {
  constructor(
    public readonly id: number | undefined,
    public readonly name: string,
    public readonly startDate: string,
    public readonly active: boolean,
    public readonly endDate?: string,
    public readonly description?: string,
    public readonly allActivities?: boolean,
    public readonly authorizedActivities?: DispositifActivity[],
    public readonly participantIds?: number[],
  ) {}
}
